import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import * as S from './styles';
import api from '../../services/api';
import downloadFile from '../../utils/downloadFile';
import { notifyApiError } from '../../services/apiError';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';
import { store } from 'react-notifications-component';
import { theme } from '../../styles/theme';
import { Loading } from '../loading';
import IconXlsx from '../../assets/icons/icon-baixar-xlsx.png';

const MESES_ABREV = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];

const formatMesLabel = (mesAno) => {
    const [mes] = mesAno.split('/');
    return MESES_ABREV[parseInt(mes, 10) - 1] || mesAno;
};

const GraphicReview = ({ dtInicial, dtFinal, ...props }) => {
    const dataInicial = dtInicial;
    const dataFinal = dtFinal;

    const [dataGraph, setDataGraph] = useState(null);
    const [loadingXls, setLoadingXls] = useState(false);

    const gerarXLS = async () => {
        try {
            setLoadingXls(true);
            window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';

            const response = await api.post('/relatorios/geral', {
                dtInicial: dataInicial,
                dtFinal: dataFinal,
            });

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-geral.xlsx');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 6000,
                    onScreen: true
                }
            });
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            setLoadingXls(false);
            window.onbeforeunload = null;
        }
    }

    const searchInitialData = async () => {
        setDataGraph(null);

        try {
            const response = await api.post('/relatorios/receitas/grafico', {
                dtInicial: dataInicial,
                dtFinal: dataFinal,
            });

            setDataGraph({
                labels: response.data.meses.map(formatMesLabel),
                datasets: [
                    {
                        data: response.data.qtdReceita,
                        borderColor: theme.colors.green.Verde_AgroReceita,
                        backgroundColor: theme.colors.green.Verde_AgroReceita,
                        pointBackgroundColor: theme.colors.green.Verde_AgroReceita,
                        pointBorderColor: '#fff',
                        pointBorderWidth: 2,
                        pointRadius: 5,
                        pointHoverRadius: 6,
                        borderWidth: 2,
                        tension: 0.4,
                        fill: false,
                    },
                ],
            });
        } catch (error) {
            notifyApiError(error, 'Falha ao carregar receitas emitidas por mês.');
        }
    }

    useEffect(() => {
        searchInitialData();
    }, [dtInicial, dtFinal])

    return (
        <S.Container>
            <S.Header>
                <S.Title>Receitas emitidas por mês</S.Title>
                <a onClick={() => !loadingXls && gerarXLS()} style={{ cursor: 'pointer' }}>
                    <img width={18} src={IconXlsx} alt="Baixar XLSX" />
                </a>
            </S.Header>

            <S.ChartWrapper>
                {dataGraph && !loadingXls ? (
                    <Line
                        data={dataGraph}
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: { display: false },
                            },
                            scales: {
                                y: {
                                    beginAtZero: true,
                                    grid: { color: theme.colors.gray.Cinza_11 },
                                    border: { display: false },
                                    ticks: { display: false },
                                },
                                x: {
                                    grid: { display: false },
                                    border: { display: false },
                                    ticks: {
                                        color: theme.colors.gray.Cinza_7,
                                        font: { size: 11, weight: 700 },
                                    },
                                },
                            },
                        }}
                    />
                ) : (
                    <S.LoadingBox>
                        <Loading size="32px" color={theme.colors.green.Bandeira} noMargin />
                    </S.LoadingBox>
                )}
            </S.ChartWrapper>
        </S.Container>
    )
}

export default GraphicReview;
